import { WorkflowLegalIdVerification } from "../components/workflowLegalId/WorkflowLegalIdVerification";

export function WorkflowLegalIdPage() {
  return <WorkflowLegalIdVerification />;
}
